var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useOkapiKy } from '@folio/stripes/core';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { usePollingToggle } from '../usePollingToggle';
import { PULLING_STATUS_DELAY } from '../constants';
export var useRefreshStatusPolling = function (_a) {
    var _b;
    var listId = _a.listId, inProgressRefresh = _a.inProgressRefresh, onErrorPolling = _a.onErrorPolling, onSuccessPolling = _a.onSuccessPolling, onError = _a.onError, onCancelRefresh = _a.onCancelRefresh;
    var ky = useOkapiKy();
    var _c = usePollingToggle(Boolean(inProgressRefresh === null || inProgressRefresh === void 0 ? void 0 : inProgressRefresh.id)), isPollingEnabled = _c.isPollingEnabled, setPollingOff = _c.setPollingOff, setPollingOn = _c.setPollingOn;
    var _d = useState((_b = inProgressRefresh === null || inProgressRefresh === void 0 ? void 0 : inProgressRefresh.id) !== null && _b !== void 0 ? _b : ''), currentRefreshId = _d[0], setCurrentRefreshId = _d[1];
    var stopPolling = function () {
        setCurrentRefreshId('');
        setPollingOff();
    };
    var startPolling = function (refreshId) {
        setCurrentRefreshId(refreshId);
        setPollingOn();
    };
    var _e = useQuery({
        queryKey: ['listDetailsStatusPulling', listId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ky.get("lists/".concat(listId))];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.json()];
                }
            });
        }); },
        cacheTime: 0,
        enabled: isPollingEnabled,
        refetchInterval: PULLING_STATUS_DELAY,
        refetchOnWindowFocus: false,
        onSuccess: function (data) {
            var failedRefresh = data.failedRefresh, successRefresh = data.successRefresh;
            var shouldUpdateID = data.inProgressRefresh && currentRefreshId !== data.inProgressRefresh.id;
            var isRefreshCanceled = !data.inProgressRefresh && successRefresh && successRefresh.id !== currentRefreshId;
            if (data.inProgressRefresh && shouldUpdateID) {
                setCurrentRefreshId(data.inProgressRefresh.id);
            }
            if (data.inProgressRefresh) {
                return;
            }
            if (failedRefresh) {
                onErrorPolling(failedRefresh.error.code);
            }
            else if (isRefreshCanceled) {
                onCancelRefresh === null || onCancelRefresh === void 0 ? void 0 : onCancelRefresh();
            }
            else {
                onSuccessPolling(data);
            }
            stopPolling();
        },
        onError: function (error) {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
    }), refetch = _e.refetch, polledData = _e.data, isLoading = _e.isLoading;
    return {
        startPolling: startPolling,
        stopPolling: stopPolling,
        isPollingInProgress: isPollingEnabled || isLoading,
        poolStatus: refetch,
        polledData: polledData
    };
};
